import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {WaButtonDirective, WaCalloutDirective, WaCardDirective, WaIconDirective} from "angular-awesome";

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, WaButtonDirective, WaIconDirective, WaCardDirective, WaCalloutDirective]
})
export class UploadComponent {

  @Output() selectedEvent = new EventEmitter<File | null>();

  fileToUpload: File | null = null;

  onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;

    if (!target || !target.files)
      return;

    this.fileToUpload = target.files[0];
    this.selectedEvent.emit(this.fileToUpload);
  }
}
